import StepHandler from './StepHandler-redux';

export default StepHandler;
